<div class="inbox-message-view">
  <div class="inbox-message-view__header">
    <h3 class="inbox-message-view__subject">{{ message.subject }}</h3>
    <div class="inbox-message-view__date">{{ message.date | date: "dd-MM-yyyy" }}</div>
  </div>
  <img class="inbox-message-view__image" [src]="message.imageUrl" *ngIf="message.imageUrl" />
  <div class="inbox-message-view__caption">{{ "inbox.label.caption" | translate }}</div>
  <p class="inbox-message-view__message">
    <span class="inbox-message-view__headline">{{ message.headline }}</span>
    {{ message.body }}
  </p>
  <div class="inbox-message-view__actions">
    <button class="button button--secondary button--destructive" (click)="deleteMessage($event)">
      <i class="icon icon-ui-trash"></i>
      <span>{{ "inbox.label.remove" | translate }}</span>
    </button>
    <div class="inbox-message-view__buttons">
      <a
        class="button"
        [ngClass]="{ 'button--secondary': index !== 0 }"
        *ngFor="let action of message.actions; index as index"
        [airLink]="action.url"
        [target]="getActionTarget(action.url)"
        (click)="trackMessageAction()"
      >
        {{ action.text }}
      </a>
    </div>
  </div>
</div>
